import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveViewService {
  private currentViewSubject = new BehaviorSubject<string>(this.getStoredView());
  public currentView$ = this.currentViewSubject.asObservable();

  private getStoredView(): string {
    return localStorage.getItem('responsiveView') || 'desktop';
  }

  setView(view: string) {
    localStorage.setItem('responsiveView', view);
    this.currentViewSubject.next(view);
  }

  getCurrentView(): string {
    return this.currentViewSubject.value;
  }
}